import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import MainPage from "../pages/main/main";
import LandingPage from "../pages/main/landing";

const AppRouter = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path='/landing' element={<LandingPage />} />
        <Route path='/' element={<MainPage />} />
      </Routes>
    </HashRouter>
  );
};

export default AppRouter;
